import { Link } from "react-router-dom";
import { ChevronRight, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

/* Reusable presentational pieces used by FullPage components that
   don't compose GenericInfoPage. Keeps breadcrumb + internal-link
   markup consistent across the SEO surface. */

export function PageBreadcrumb({ items = [] }) {
  const { t } = useTranslation();
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="page-breadcrumb"
      className="flex items-center gap-1.5 text-[12px] text-[color:var(--text-3)] mb-5 flex-wrap"
    >
      <Link to="/" className="hover:text-brand transition-colors">{t("seoBlocks.home", "Home")}</Link>
      {items.map((b) => (
        <span key={b.to || b.label} className="flex items-center gap-1.5">
          <ChevronRight size={11} className="opacity-50" />
          {b.to ? (
            <Link to={b.to} className="hover:text-brand transition-colors">{b.label}</Link>
          ) : (
            <span className="text-[color:var(--text-2)]">{b.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

export function RelatedLinks({ items = [] }) {
  const { t } = useTranslation();
  if (!items.length) return null;
  return (
    <section
      data-testid="related-at-ofinancial"
      className="max-w-7xl mx-auto px-5 lg:px-8 mt-16 pt-10 border-t border-[color:var(--line)]/60"
    >
      <div className="text-[12px] uppercase tracking-[0.22em] text-[color:var(--text-3)] font-semibold mb-4">
        {t("seoBlocks.relatedAtOfinancial", "Related at OFinancial Markets")}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {items.map((r) => (
          <Link
            key={r.to}
            to={r.to}
            data-testid={`related-link-${r.to.replace(/[^a-z0-9]+/gi, "-")}`}
            className="group flex items-start gap-3 p-4 rounded-xl card-beam hover:border-brand/40 transition-colors"
          >
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-[color:var(--text-1)] group-hover:text-brand transition-colors">
                {r.label}
              </div>
              {r.tagline && (
                <div className="text-[12px] text-[color:var(--text-3)] mt-0.5 font-light">
                  {r.tagline}
                </div>
              )}
            </div>
            <ArrowRight size={14} className="text-[color:var(--text-3)] group-hover:text-brand mt-1 shrink-0 transition-colors" />
          </Link>
        ))}
      </div>
    </section>
  );
}
